import { Button, Typography } from "@mui/material";
import * as React from "react";
import { CustomButtonStyle } from "./CustomButtonStyle";

export default function CustomButton({
  id,
  title,
  Input,
  onClick,
  hide,
  disable
}) {
  return (
    <CustomButtonStyle
      variant="contained"
      component="label"
      id={id}
      onClick={disable ? ()=>{} : onClick}
      disable={disable ? disable.toString() : "false"}
      sx={
        hide
          ? { display: "none" }
          : disable
          ? {
              textAlign: "center",
              borderRadius: "5px",
              fontWeight: 500,
              fontSize: "11px",
              backgroundColor: "#B8B8B8",
              color: "white",
              ":hover": { backgroundColor: "#B8B8B8" },
            }
          : {
              textAlign: "center",
              borderRadius: "5px",
              fontWeight: 500,
              fontSize: "11px",
              backgroundColor: "#c59812",
              color: "white !important",
              ":hover": { backgroundColor: "#c99b13", fontWeight: 700 },
            }
      }
      size="large"
    >
      <Typography
        sx={{
          typography: { sm: "h5", xs: "body2", md: "h1" },
          fontSize: {sm: "20px", xs: '14px', md: '24px'}
        }}
      >
        {title}
        {Input}
      </Typography>
    </CustomButtonStyle>
  );
}
